import { render, staticRenderFns } from "./ReportCrowdedDetail.vue?vue&type=template&id=06a192a8"
import script from "./ReportCrowdedDetail.vue?vue&type=script&lang=js"
export * from "./ReportCrowdedDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportCrowdedDetail.vue?vue&type=style&index=0&id=06a192a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports